// @ts-nocheck
import { populate } from 'populate';
import type { Container } from 'pixi.js';

const raw = {
  list: [
    {
      id: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      type: 'Container',
      name: 'root',
      className: 'locaSkin_SPL',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: ''
    },
    {
      id: 'e5b2efa2-6c10-4d9c-8a24-4ace565eb85c',
      type: 'Sprite',
      name: '',
      className: '',
      x: 94,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'New_Rays',
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      stateByName: {
        it_IT: {
          x: 69,
          y: -12
        },
        de_DE: {
          x: 130
        },
        ko_KR: {
          y: 0,
          x: 93
        }
      }
    },
    {
      id: '1ac2a3b4-9157-4374-9720-2c201e165c0b',
      type: 'Sprite',
      name: '',
      className: '',
      x: 93,
      y: 23,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 0.5
      },
      angle: 0,
      alpha: 0.5,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Circle_Glow',
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      stateByName: {
        it_IT: {
          x: 70,
          y: -5,
          scale: {
            x: 1.2
          }
        },
        de_DE: {
          x: 140,
          y: 6
        },
        ko_KR: {
          x: 115,
          y: -3
        }
      }
    },
    {
      id: '66ac4e35-898d-45e7-a00b-f2a0ddbb5e79',
      type: 'Sprite',
      name: '',
      className: '',
      x: 95,
      y: -20,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: -1,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Race_Event_Title_Flag',
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      stateByName: {
        it_IT: {
          x: 80,
          y: -34,
          scale: {
            x: 1.2,
            y: 1.1
          },
          angle: -1.6
        },
        fr_FR: {
          x: 86,
          y: -28
        },
        de_DE: {
          x: 140,
          scale: {
            x: 0.9
          }
        },
        pt_PT: {
          x: 100,
          y: -29,
          scale: {
            x: 1.2
          }
        },
        pl_PL: {
          scale: {
            x: 0.8,
            y: 1
          },
          x: 110,
          y: -30,
          angle: -4.7
        },
        nl_NL: {
          scale: {
            x: 1.2
          },
          x: 77,
          y: -21
        },
        ko_KR: {
          x: 123,
          y: -49,
          scale: {
            x: 0.9
          }
        },
        ja_JP: {
          x: 104,
          y: -16,
          angle: -8.1,
          scale: {
            y: 1.3
          }
        },
        es_ES: {
          x: 135,
          scale: {
            x: 1.1
          }
        }
      }
    },
    {
      id: '1c08082e-0d3e-4372-a73c-653a6d5bcaa8',
      type: 'Text',
      name: '',
      className: '',
      x: -131,
      y: -23,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: -7.6,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'Race',
      localize: false,
      maxWidth: 0,
      maxHeight: 0,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 100,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: '#24a1fe',
        stroke: '#fff8d9',
        strokeThickness: 20,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: true,
        dropShadowAlpha: 1,
        dropShadowAngle: 1.5,
        dropShadowBlur: 0,
        dropShadowColor: '#c18d6c',
        dropShadowDistance: 8,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      stateByName: {
        it_IT: {
          text: 'Corsa',
          style: {
            fontSize: 70
          },
          x: -152
        },
        fr_FR: {
          text: 'Course',
          style: {
            fontSize: 70
          },
          x: -145,
          y: -30
        },
        de_DE: {
          text: 'Rennen',
          style: {
            fontSize: 80
          },
          x: -106
        },
        pt_PT: {
          text: 'Corrida',
          style: {
            fontSize: 70
          },
          x: -155
        },
        pl_PL: {
          text: 'Wyścig',
          style: {
            fontSize: 80
          },
          x: -115
        },
        nl_NL: {
          style: {
            fontSize: 80
          },
          x: -149,
          y: -17
        },
        ko_KR: {
          text: '보상을',
          style: {
            fontWeight: 'bolder',
            fill: '#fe9c00'
          },
          x: -122
        },
        ja_JP: {
          text: '報酬',
          style: {
            fontWeight: 'bolder',
            fill: '#fe9c00',
            fontSize: 100
          },
          scale: {
            x: 1,
            y: 0.9
          },
          x: -122,
          y: -19
        },
        es_ES: {
          text: 'Carrera',
          style: {
            fontSize: 80
          }
        }
      }
    },
    {
      id: 'e3549420-d2ea-44ad-ae08-9ea7f88c2fb0',
      type: 'Text',
      name: '',
      className: '',
      x: -136,
      y: 44,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: -7.6,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'to',
      localize: false,
      maxWidth: 0,
      maxHeight: 0,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 60,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: '#24a1fe',
        stroke: '#fff8d9',
        strokeThickness: 20,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: true,
        dropShadowAlpha: 1,
        dropShadowAngle: 1.5,
        dropShadowBlur: 0,
        dropShadowColor: '#c18d6c',
        dropShadowDistance: 8,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      stateByName: {
        it_IT: {
          text: 'alla',
          style: {
            fontSize: 40
          },
          x: -180,
          y: 42
        },
        fr_FR: {
          text: 'à la',
          style: {
            fontSize: 40
          },
          x: -197,
          y: 45
        },
        de_DE: {
          text: 'zur',
          style: {
            fontSize: 50
          },
          x: -181,
          y: 45
        },
        pt_PT: {
          text: 'pela',
          style: {
            fontSize: 40
          },
          x: -185,
          y: 42
        },
        pl_PL: {
          text: 'po',
          style: {
            fontSize: 50
          },
          x: -125
        },
        nl_NL: {
          text: 'naar de',
          style: {
            fontSize: 40
          },
          x: -155,
          y: 41
        },
        ko_KR: {
          text: '향한',
          style: {
            fontWeight: 'bolder',
            fill: '#24a1fe'
          },
          x: -29,
          y: 60
        },
        ja_JP: {
          text: 'への',
          style: {
            fontWeight: 'bolder',
            fontSize: 60,
            fill: '#24a1fe'
          },
          x: -102,
          y: 66
        },
        es_ES: {
          text: 'hacia la',
          style: {
            fontSize: 30
          },
          x: -193
        }
      }
    },
    {
      id: '7b25b605-5d49-44d9-860f-7d337312dc48',
      type: 'Text',
      name: '',
      className: '',
      x: 76,
      y: 43,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: -3,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'Reward',
      localize: false,
      maxWidth: 0,
      maxHeight: 0,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 100,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: '#fe9c00',
        stroke: '#fff8d9',
        strokeThickness: 20,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: true,
        dropShadowAlpha: 1,
        dropShadowAngle: 1.9,
        dropShadowBlur: 0,
        dropShadowColor: '#c18d6c',
        dropShadowDistance: 8,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      stateByName: {
        it_IT: {
          text: 'Ricompensa',
          style: {
            fontSize: 70
          },
          x: 60,
          y: 27
        },
        fr_FR: {
          text: 'Récompense',
          style: {
            fontSize: 70
          },
          x: 51,
          y: 31
        },
        de_DE: {
          text: 'Belohnung',
          style: {
            fontSize: 80
          },
          x: 65
        },
        pt_PT: {
          text: 'Recompensa',
          style: {
            fontSize: 70
          },
          x: 69,
          y: 30
        },
        pl_PL: {
          text: 'Nagrodę',
          style: {
            fontSize: 80
          },
          x: 76,
          y: 36
        },
        nl_NL: {
          text: 'Beloning',
          style: {
            fontSize: 80
          },
          y: 35,
          x: 90
        },
        ko_KR: {
          text: '경주',
          style: {
            fontWeight: 'bolder',
            fill: '#24a1fe'
          },
          x: 139
        },
        ja_JP: {
          text: 'レース',
          style: {
            fontWeight: 'bolder',
            fill: '#24a1fe'
          },
          x: 100,
          y: 65
        },
        es_ES: {
          text: 'Recompensa',
          style: {
            fontSize: 70
          }
        }
      }
    }
  ],
  x: 0,
  y: 0,
  width: 664,
  height: 667,
  version: '1.0.0',
  stateNames: [
    'it_IT',
    'en_US',
    'fr_FR',
    'de_DE',
    'pt_PT',
    'pl_PL',
    'nl_NL',
    'ko_KR',
    'ja_JP',
    'es_ES'
  ],
  handleResize: false
} as const;

export class RaceEventTitleLocalizationsLayout {
  static raw = raw;
  root!: Container;
  locaSkin_SPL!: (Container)[];
  StateName!: 'it_IT' | 'en_US' | 'fr_FR' | 'de_DE' | 'pt_PT' | 'pl_PL' | 'nl_NL' | 'ko_KR' | 'ja_JP' | 'es_ES';

  constructor() {
    populate(this, raw);
  }
}
